import { render, staticRenderFns } from "./StepTitle.vue?vue&type=template&id=5126ce6e&scoped=true&functional=true&"
var script = {}
import style0 from "./StepTitle.vue?vue&type=style&index=0&id=5126ce6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5126ce6e",
  null
  
)

export default component.exports